import type { HTMLProps } from "react";

import {
    CheckboxContainer,
    HiddenCheckbox,
    StyledCheckbox,
    StyledDashIcon,
    StyledCheckIcon,
} from "./checkbox.styles";

interface CheckboxProps extends HTMLProps<HTMLInputElement> {
    className?: string;
    checked: boolean;
    isPartialSelection?: boolean;
}

export const Checkbox = ({ className, checked, isPartialSelection = false }: CheckboxProps) => (
    <CheckboxContainer className={className}>
        <HiddenCheckbox defaultChecked={checked} />
        <StyledCheckbox
            checked={checked || isPartialSelection}
            className={`styled-checkbox ${checked || isPartialSelection ? "checked" : "unchecked"}`}
        >
            {checked && !isPartialSelection && <StyledCheckIcon fill="#121212" />}

            {isPartialSelection && <StyledDashIcon fill="#121212" />}
        </StyledCheckbox>
    </CheckboxContainer>
);

export default Checkbox;
